<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 367.6 420">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          class="svg-secondary--low"
          d="M59.4,248.9h0a4.29,4.29,0,0,1-2.2-3.8V177.5L39.3,167.3V287.8L175.1,210l-21.7-12.4L63.8,248.9A4.33,4.33,0,0,1,59.4,248.9Z"
        />
        <path
          class="svg-secondary--mid"
          d="M147.9,355V334.6l-58-33.2a4.38,4.38,0,0,1,0-7.6l89.5-51.3V217.6L43.8,295.4Z"
        />
        <path
          class="svg-secondary--low"
          d="M156.7,362.6a4.29,4.29,0,0,1-2.2,3.8,4.33,4.33,0,0,1-4.4,0L32.8,299.2a4.29,4.29,0,0,1-2.2-3.8V159.7a4.29,4.29,0,0,1,2.2-3.8,4.33,4.33,0,0,1,4.4,0l26.6,15.3,59,33.8,21.7-12.5L8.8,114.7V310.2L179.4,408V252.6l-22.8,13.1v96.9Z"
        />
        <path
          class="svg-bg"
          d="M306.6,107.2a4.29,4.29,0,0,1-2.2,3.8L218,160.6v24.9l136.5-78.2L183.9,9.5,13.3,107.3,149,185.1V159.6L94.1,128.5,63.4,111.1a4.38,4.38,0,0,1,0-7.6L181.7,35.7a4.33,4.33,0,0,1,4.4,0l118.3,67.8A4.33,4.33,0,0,1,306.6,107.2Z"
        />
        <path
          class="svg-secondary--low"
          d="M179.5,202.5V47L74.4,107.3l21.9,12.4,55-30.9a4.33,4.33,0,0,1,4.4,0,4.5,4.5,0,0,1,2.2,3.8v97.5Z"
        />
        <path
          class="svg-secondary--low"
          d="M244.9,205l85.7-49.1a4.33,4.33,0,0,1,4.4,0,4.29,4.29,0,0,1,2.2,3.8V295.4a4.29,4.29,0,0,1-2.2,3.8L215.8,367.5a4.28,4.28,0,0,1-2.2.6,4.44,4.44,0,0,1-4.4-4.4V264.6l-20.9-12V408.1l170.6-97.8V114.8L222.6,192.9Z"
        />
        <path
          class="svg-secondary--mid"
          d="M280,297.6a4.29,4.29,0,0,1-2.2,3.8h0L218,335.7v20.4l106-60.8L188.3,217.5v24.9l89.5,51.4A4.5,4.5,0,0,1,280,297.6Z"
        />
        <path
          class="svg-secondary--low"
          d="M192.7,210l135.7,77.8V167.2l-17.9,10.2V245a4.29,4.29,0,0,1-2.2,3.8,4.33,4.33,0,0,1-4.4,0L213.6,198Z"
        />
        <path
          class="svg-secondary--low"
          d="M209.2,91.4a4.29,4.29,0,0,1,2.2-3.8,4.33,4.33,0,0,1,4.4,0h0l56,32.1,21.7-12.5L188.3,46.9V202.4l20.9-12v-99Z"
        />
        <path
          class="svg-secondary"
          d="M365.4,103.4,186,.6a4.33,4.33,0,0,0-4.4,0L2.2,103.4A4.29,4.29,0,0,0,0,107.2V312.8a4.29,4.29,0,0,0,2.2,3.8L181.6,419.4a4.33,4.33,0,0,0,4.4,0L365.4,316.6a4.29,4.29,0,0,0,2.2-3.8V107.2A4.41,4.41,0,0,0,365.4,103.4ZM179.5,408.1,8.9,310.3V114.8l135.7,77.8L122.8,205l-59-33.8L37.2,155.9a4.33,4.33,0,0,0-4.4,0,4.29,4.29,0,0,0-2.2,3.8V295.4a4.29,4.29,0,0,0,2.2,3.8l117.3,67.2a4.33,4.33,0,0,0,4.4,0,4.29,4.29,0,0,0,2.2-3.8V265.7l22.8-13.1ZM155.6,88.7a4.33,4.33,0,0,0-4.4,0l-55,30.9L74.3,107.2,179.4,46.9V202.4l-21.8-12.5V92.4A4.06,4.06,0,0,0,155.6,88.7ZM149,100v49.5l-43.8-24.8Zm4.4,97.6L175.1,210,39.4,287.8V167.2l17.9,10.2V245a4.29,4.29,0,0,0,2.2,3.8h0a4.33,4.33,0,0,0,4.4,0ZM66,237.6V182.5L114,210Zm113.5,4.9L90,293.8a4.38,4.38,0,0,0,0,7.6l58,33.2V355L43.8,295.4l135.7-77.8Zm-31.6,82-47-26.9,47-26.9ZM186,35.6a4.33,4.33,0,0,0-4.4,0L63.3,103.4a4.29,4.29,0,0,0-2.2,3.8,4.5,4.5,0,0,0,2.2,3.8L94,128.4l54.9,31.1V185L13.2,107.2,183.8,9.4l170.6,97.8L217.9,185.4V160.5l86.4-49.6a4.38,4.38,0,0,0,0-7.6ZM303.9,248.9a4.33,4.33,0,0,0,4.4,0,4.5,4.5,0,0,0,2.2-3.8V177.5l17.9-10.2V287.8L192.7,210l20.9-12ZM253.7,210l48-27.5v55.1ZM217.9,98.9l45,25.8-45,25.8Zm-29.6-52,105.2,60.3-21.7,12.5-56-32.1h0a4.33,4.33,0,0,0-4.4,0,4.29,4.29,0,0,0-2.2,3.8v99.1l-20.9,12V46.9Zm0,170.7L324,295.4,218,356.2V335.8l59.8-34.4h0a4.38,4.38,0,0,0,0-7.6l-89.5-51.3Zm29.6,52,48.9,28-48.9,28Zm141,40.7L188.3,408.1V252.6l20.9,12v99.1a4.44,4.44,0,0,0,4.4,4.4,4.28,4.28,0,0,0,2.2-.6L335,299.2a4.29,4.29,0,0,0,2.2-3.8V159.7a4.29,4.29,0,0,0-2.2-3.8,4.33,4.33,0,0,0-4.4,0L244.9,205l-22.3-12.1,136.3-78.1Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "SvgLogoCube",
  }
</script>

<style lang="scss">
  .header__logo .svg-secondary--low {
    stroke: rgba(var(--svg-bg), 0.8);
    stroke-width: 20px;
    stroke-dasharray: 40% 50%;
    animation: stroke 4s infinite linear;
    stroke-linecap: round;
  }
  // .svg-secondary {
  //   stroke: red;
  //   stroke-dasharray: 7%;
  //       animation: stroke 4s infinite linear;
  // }
  .svg-secondary--low {
    stroke: rgba(var(--svg-bg), 0.8);
    stroke-dasharray: 50%;
  }
  // .svg-secondary--mid {
  //   stroke: #00b0ff;
  //   stroke-dasharray: 90%;
  // }
  // .text-copy:nth-child(4) {stroke:#651fff; stroke-dasharray: 28%;}
  // .text-copy:nth-child(5) {stroke:#2962ff; stroke-dasharray: 35%;}
  @keyframes stroke {
    50% {
      stroke-dashoffset: 50%;
      stroke-dasharray: 0 100%;
    }
  }
</style>
